module.exports = __webpack_public_path__ + "img/未选@2x.fc0911bc.png";